/* eslint-disable */
/* tslint:disable */
/* auto-generated react proxies */
import { createReactComponent } from './react-component-lib';
import { applyPolyfills, defineCustomElements } from '@duetds/components/lib/loader';
applyPolyfills().then(() => defineCustomElements());
export const DuetAlert = /*@__PURE__*/ createReactComponent('duet-alert');
export const DuetBadge = /*@__PURE__*/ createReactComponent('duet-badge');
export const DuetButton = /*@__PURE__*/ createReactComponent('duet-button');
export const DuetCaption = /*@__PURE__*/ createReactComponent('duet-caption');
export const DuetCard = /*@__PURE__*/ createReactComponent('duet-card');
export const DuetCheckbox = /*@__PURE__*/ createReactComponent('duet-checkbox');
export const DuetChoice = /*@__PURE__*/ createReactComponent('duet-choice');
export const DuetChoiceGroup = /*@__PURE__*/ createReactComponent('duet-choice-group');
export const DuetCollapsible = /*@__PURE__*/ createReactComponent('duet-collapsible');
export const DuetCookieConsent = /*@__PURE__*/ createReactComponent('duet-cookie-consent');
export const DuetDatePicker = /*@__PURE__*/ createReactComponent('duet-date-picker');
export const DuetDivider = /*@__PURE__*/ createReactComponent('duet-divider');
export const DuetEmptyState = /*@__PURE__*/ createReactComponent('duet-empty-state');
export const DuetFieldset = /*@__PURE__*/ createReactComponent('duet-fieldset');
export const DuetFooter = /*@__PURE__*/ createReactComponent('duet-footer');
export const DuetGrid = /*@__PURE__*/ createReactComponent('duet-grid');
export const DuetGridItem = /*@__PURE__*/ createReactComponent('duet-grid-item');
export const DuetHeader = /*@__PURE__*/ createReactComponent('duet-header');
export const DuetHeading = /*@__PURE__*/ createReactComponent('duet-heading');
export const DuetHero = /*@__PURE__*/ createReactComponent('duet-hero');
export const DuetIcon = /*@__PURE__*/ createReactComponent('duet-icon');
export const DuetInput = /*@__PURE__*/ createReactComponent('duet-input');
export const DuetLabel = /*@__PURE__*/ createReactComponent('duet-label');
export const DuetLayout = /*@__PURE__*/ createReactComponent('duet-layout');
export const DuetLink = /*@__PURE__*/ createReactComponent('duet-link');
export const DuetList = /*@__PURE__*/ createReactComponent('duet-list');
export const DuetListItem = /*@__PURE__*/ createReactComponent('duet-list-item');
export const DuetLogo = /*@__PURE__*/ createReactComponent('duet-logo');
export const DuetModal = /*@__PURE__*/ createReactComponent('duet-modal');
export const DuetNotification = /*@__PURE__*/ createReactComponent('duet-notification');
export const DuetNotificationDrawer = /*@__PURE__*/ createReactComponent('duet-notification-drawer');
export const DuetNumberInput = /*@__PURE__*/ createReactComponent('duet-number-input');
export const DuetParagraph = /*@__PURE__*/ createReactComponent('duet-paragraph');
export const DuetRadio = /*@__PURE__*/ createReactComponent('duet-radio');
export const DuetRadioGroup = /*@__PURE__*/ createReactComponent('duet-radio-group');
export const DuetRangeSlider = /*@__PURE__*/ createReactComponent('duet-range-slider');
export const DuetSelect = /*@__PURE__*/ createReactComponent('duet-select');
export const DuetSpacer = /*@__PURE__*/ createReactComponent('duet-spacer');
export const DuetSpinner = /*@__PURE__*/ createReactComponent('duet-spinner');
export const DuetStep = /*@__PURE__*/ createReactComponent('duet-step');
export const DuetStepper = /*@__PURE__*/ createReactComponent('duet-stepper');
export const DuetTab = /*@__PURE__*/ createReactComponent('duet-tab');
export const DuetTabGroup = /*@__PURE__*/ createReactComponent('duet-tab-group');
export const DuetTable = /*@__PURE__*/ createReactComponent('duet-table');
export const DuetTextarea = /*@__PURE__*/ createReactComponent('duet-textarea');
export const DuetToggle = /*@__PURE__*/ createReactComponent('duet-toggle');
export const DuetTooltip = /*@__PURE__*/ createReactComponent('duet-tooltip');
export const DuetTray = /*@__PURE__*/ createReactComponent('duet-tray');
export const DuetVisuallyHidden = /*@__PURE__*/ createReactComponent('duet-visually-hidden');
//# sourceMappingURL=components.js.map